import { combineReducers } from 'redux';

import myPersonalInfo from './myPersonalInfoReducer';
import updateEmailAndMobile from './updateEmailandMobileReducer';
import changePassword from './changePasswordReducer';
import deactivateAccount from './deactivateAccountReducer';

const myProfileInfo = combineReducers({
	myPersonalInfo,
	updateEmailAndMobile,
	changePassword,
	deactivateAccount
});

export default myProfileInfo;
